
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_18005_4821)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.724 13.288c.188.133.43.166.646.084a.677.677 0 00.422-.49C12.3 10.5 13.53 4.47 13.99 2.303a.455.455 0 00-.151-.442.467.467 0 00-.465-.082C10.928 2.685 3.395 5.511.316 6.65A.482.482 0 000 7.116a.483.483 0 00.346.446c1.38.413 3.193.987 3.193.987s.847 2.558 1.289 3.86a.511.511 0 00.352.335.506.506 0 00.473-.12l1.806-1.706s2.083 1.528 3.265 2.37zM4.302 8.226l.98 3.23.217-2.045 5.941-5.358a.162.162 0 00.02-.22.166.166 0 00-.22-.038L4.302 8.226z","fill":"#039BE5"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_18005_4821"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h14v14H0z"}})])])])
          )
        }
      }
    